<form (ngSubmit)="onSubmit()" [ngClass]="{'uploaded-view': viewUploaded}">
    <div class="title-outer">
        <h2 class="form-title">{{ languageService.languageJSON.ComponentRecalled_UploadList }}</h2>
    </div>

    <div class="upload-outer" [hidden]="loading">
        <div class="upload-file" *ngIf="!viewUploaded">
            <label for="recalled-upload" name="avatar_btn" class="upload-file-text" appDnd
                (fileDropped)="onFileDropped($event)">
                <img class="dnd-icon" src="assets/icons/drop-here.svg" />
                <span>{{ languageService.languageJSON.ComponentRecalled_ChooseOrDnd }}</span>
            </label>
            <input style="display: none;" name="recalled-upload" type="file" id="recalled-upload"
                (change)="recalledUpload($event)" accept=".csv" />
        </div>

        <div class="upload-file uploaded" *ngIf="viewUploaded">
            <label>
                <img class="file-icon" src="assets/icons/file.svg" />
                {{ languageService.languageJSON.ComponentRecalledUploads_SelectedFile + uploadedFileName }}
            </label>
            <div class="clear-icon" (click)="clearUpload()">×</div>
        </div>
        <p *ngIf="!viewUploaded">{{ languageService.languageJSON.Globa_AcceptedFileCSVSerial }}</p>
    </div>

    <app-loading-animation class="edit-animation" *ngIf="loading"></app-loading-animation>

    <div class="form-section" [hidden]="loading">
        <div class="flex-outer flex-column">
            <div class="flex-col">
                <div class="flex-row">
                    <label>{{ languageService.languageJSON.ComponentRecalledUploads_MarkComponents }}</label>
                    <mat-select [(value)]="selectedMarkStatus" hideSingleSelectionIndicator="true">
                        <mat-option *ngFor="let status of markStatus" [value]="status.Method" selected>{{
                            status.DisplayName }}
                        </mat-option>
                    </mat-select>
                </div>
            </div>
        </div>
    </div>

    <div class="form-section-send" [hidden]="loading" [ngClass]="{inactive: !viewUploaded || !selectedMarkStatus}">
        <button type="submit">{{ languageService.languageJSON.ReleaseDetails_Upload}}</button>
        <button class="back-button" (click)="goBack()">{{ languageService.languageJSON.Global_Cancel}}</button>
    </div>
</form>